import { useEffect, useState } from 'react';
import { resolveCatalogGridColumns } from '../config/landingCatalog';

export default function useCatalogGridColumns() {
  const [columns, setColumns] = useState(() =>
    typeof window !== 'undefined' ? resolveCatalogGridColumns(window.innerWidth) : 4
  );

  useEffect(() => {
    const onResize = () => setColumns(resolveCatalogGridColumns(window.innerWidth));
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return columns;
}
